/**
 * Horizontal Infinite Slider for Privacy / “Mais informações” (contato)
 */

// Configuration (same as horizontalSliderLogos)
const config = {
  SCROLL_SPEED: 1.75,
  LERP_FACTOR: 0.05,
  MAX_VELOCITY: 150,
};

// State management
const state = {
  currentX: 0,
  targetX: 0,
  slideWidth: 370,
  slides: [],
  isDragging: false,
  startX: 0,
  lastX: 0,
  lastMouseX: 0,
  lastScrollTime: Date.now(),
  isMoving: false,
  velocity: 0,
  lastCurrentX: 0,
  dragDistance: 0,
  hasActuallyDragged: false,
  isMobile: false,
  sliderData: [],
  totalSlideCount: 0,
  /** Contato garden: sem loop RAF/transform — só overflow-x nativo */
  talkGardenNative: false,
  talkGardenSizeSlides: null,
};

// Utility functions
function checkMobile() {
  state.isMobile = window.innerWidth < 1000;
}

/** Contato / Política garden mobile: carrossel com scroll horizontal nativo */
function isPrivacyGardenNativeLayout() {
  return (
    document.body.classList.contains("talk-garden-mobile") ||
    document.body.classList.contains("privacy-garden-mobile")
  );
}

function createPrivacySlideElement(index) {
  const dataIndex = index % state.totalSlideCount;

  // Create the slide as an anchor tag
  const slide = document.createElement("a");
  slide.className = "slide privacy-slide";
  slide.href = state.sliderData[dataIndex].url || "#";

  if (state.isMobile) {
    slide.style.maxWidth = "none";
    slide.style.maxHeight = "none";
    // Contato garden: largura/scroll horizontal nativo (initializeSlidesTalkGardenNative)
    if (isPrivacyGardenNativeLayout()) {
      slide.style.width = "";
      slide.style.height = "";
    } else {
      slide.style.width = "75vw";
      slide.style.height = "450px";
    }
  }

  const imageContainer = document.createElement("div");
  imageContainer.className = "slide-image";

  const img = document.createElement("img");
  img.src = state.sliderData[dataIndex].img;
  img.alt = state.sliderData[dataIndex].title || "";

  const overlay = document.createElement("div");
  overlay.className = "slide-overlay privacy-overlay";

  // Título centralizado
  const title = document.createElement("h3");
  title.className = "privacy-title-center";
  title.innerHTML = state.sliderData[dataIndex].title || "";
  overlay.appendChild(title);

  // Botão que aparece no hover
  const button = document.createElement("button");
  button.className = "privacy-button";
  button.textContent = state.sliderData[dataIndex].buttonText || "SAIBA MAIS";
  overlay.appendChild(button);

  // Handle click to prevent navigation if it was a drag
  slide.addEventListener("click", (e) => {
    if (state.dragDistance >= 10 || state.hasActuallyDragged) {
      e.preventDefault();
    }
  });

  imageContainer.appendChild(img);
  slide.appendChild(imageContainer);
  slide.appendChild(overlay);

  return slide;
}

function initializeSlides() {
  const track = document.querySelector(".privacy-slider .slide-track");
  if (!track) return;

  track.innerHTML = "";
  state.slides = [];

  checkMobile();

  const tempSlide = createPrivacySlideElement(0);
  track.appendChild(tempSlide);

  state.slideWidth = getRealSlideWidth(tempSlide);

  const viewportWidth = window.innerWidth;
  const minWidthNeeded = viewportWidth * 3;

  const slidesPerSequence = state.totalSlideCount;
  const singleSequenceWidth = slidesPerSequence * state.slideWidth;

  const copies = Math.ceil(minWidthNeeded / singleSequenceWidth) + 2;

  track.innerHTML = "";
  state.slides = [];

  const totalSlides = state.totalSlideCount * copies;

  for (let i = 0; i < totalSlides; i++) {
    const slide = createPrivacySlideElement(i);
    track.appendChild(slide);
    state.slides.push(slide);
  }

  const startOffset = -(state.totalSlideCount * state.slideWidth * 2);
  state.currentX = startOffset;
  state.targetX = startOffset;

  state.copies = copies;
}

function updateSlidePositions() {
  const track = document.querySelector(".privacy-slider .slide-track");
  if (!track) return;

  const sequenceWidth = state.slideWidth * state.totalSlideCount;

  const maxOffset = -sequenceWidth * (state.copies - 1);
  const minOffset = -sequenceWidth;

  if (state.currentX < maxOffset) {
    state.currentX += sequenceWidth;
    state.targetX += sequenceWidth;
  }

  if (state.currentX > minOffset) {
    state.currentX -= sequenceWidth;
    state.targetX -= sequenceWidth;
  }

  track.style.transform = `translate3d(${state.currentX}px, 0, 0)`;
}

function getRealSlideWidth(slide) {
  const styles = getComputedStyle(slide);
  return (
    slide.getBoundingClientRect().width +
    parseFloat(styles.marginLeft) +
    parseFloat(styles.marginRight)
  );
}

function updateMovingState() {
  state.velocity = Math.abs(state.currentX - state.lastCurrentX);
  state.lastCurrentX = state.currentX;

  const isSlowEnough = state.velocity < 0.1;
  const hasBeenStillLongEnough = Date.now() - state.lastScrollTime > 200;
  state.isMoving =
    state.hasActuallyDragged || !isSlowEnough || !hasBeenStillLongEnough;

  document.documentElement.style.setProperty(
    "--slider-moving",
    state.isMoving ? "1" : "0"
  );
}

function animate() {
  if (state.talkGardenNative) return;

  state.currentX += (state.targetX - state.currentX) * config.LERP_FACTOR;

  updateMovingState();
  updateSlidePositions();

  requestAnimationFrame(animate);
}

// Event handlers
let touchStartY = 0;

function handleTouchStart(e) {
  state.isDragging = true;
  state.startX = e.touches[0].clientX;
  touchStartY = e.touches[0].clientY;
  state.lastX = state.targetX;
  state.dragDistance = 0;
  state.hasActuallyDragged = false;
  state.lastScrollTime = Date.now();

  document.body.style.userSelect = 'none';
}

function handleTouchMove(e) {
  if (!state.isDragging) return;

  const clientX = e.touches[0].clientX;
  const clientY = e.touches[0].clientY;
  const rawDx = clientX - state.startX;
  const rawDy = clientY - touchStartY;

  /* Contato garden: prioriza scroll vertical da página — não puxa o slider com gesto vertical/diagonal */
  if (isPrivacyGardenNativeLayout()) {
    if (Math.abs(rawDy) > Math.abs(rawDx) + 12) {
      state.isDragging = false;
      document.body.style.userSelect = '';
      return;
    }
  }

  const mult = isPrivacyGardenNativeLayout() ? 1 : 1.5;
  const deltaX = rawDx * mult;
  state.targetX = state.lastX + deltaX;
  state.dragDistance = Math.abs(deltaX);

  if (state.dragDistance > 5) {
    state.hasActuallyDragged = true;
  }

  state.lastScrollTime = Date.now();
}

function handleTouchEnd() {
  state.isDragging = false;
  document.body.style.userSelect = '';

  setTimeout(() => {
    state.hasActuallyDragged = false;
  }, 100);
}

function handleMouseDown(e) {
  e.preventDefault();
  state.isDragging = true;
  state.startX = e.clientX;
  state.lastMouseX = e.clientX;
  state.lastX = state.targetX;
  state.dragDistance = 0;
  state.hasActuallyDragged = false;
  state.lastScrollTime = Date.now();

  document.body.style.cursor = 'grabbing';
  document.body.style.userSelect = 'none';
}

function handleMouseMove(e) {
  if (!state.isDragging) return;

  e.preventDefault();
  const deltaX = (e.clientX - state.lastMouseX) * 2;
  state.targetX += deltaX;
  state.lastMouseX = e.clientX;
  state.dragDistance += Math.abs(deltaX);

  if (state.dragDistance > 5) {
    state.hasActuallyDragged = true;
  }

  state.lastScrollTime = Date.now();
}

function handleMouseUp() {
  state.isDragging = false;

  document.body.style.cursor = '';
  document.body.style.userSelect = '';

  setTimeout(() => {
    state.hasActuallyDragged = false;
  }, 100);
}

function handleResize() {
  if (state.talkGardenNative && state.talkGardenSizeSlides) {
    const w = window.innerWidth;
    if (privacySliderLastResizeWidth !== null && Math.abs(w - privacySliderLastResizeWidth) < 48) {
      return;
    }
    privacySliderLastResizeWidth = w;
    state.talkGardenSizeSlides();
    return;
  }
  if (isPrivacyGardenNativeLayout()) {
    const w = window.innerWidth;
    if (privacySliderLastResizeWidth !== null && Math.abs(w - privacySliderLastResizeWidth) < 48) {
      return;
    }
    privacySliderLastResizeWidth = w;
  } else {
    privacySliderLastResizeWidth = window.innerWidth;
  }
  initializeSlides();
}

let privacySliderListenersAttached = false;
let privacySliderAnimationStarted = false;
/** Só reage a resize quando a largura muda de verdade (evita reinício ao mostrar/ocultar barra do browser no mobile — isso “pulava” o carrossel). */
let privacySliderLastResizeWidth = null;

function initializeEventListeners() {
  const slider = document.querySelector(".privacy-slider");
  if (!slider) return;
  if (privacySliderListenersAttached) return;

  privacySliderListenersAttached = true;

  slider.addEventListener("touchstart", handleTouchStart);
  slider.addEventListener("touchmove", handleTouchMove);
  slider.addEventListener("touchend", handleTouchEnd);
  slider.addEventListener("mousedown", handleMouseDown);
  slider.addEventListener("dragstart", (e) => e.preventDefault());

  document.addEventListener("mousemove", handleMouseMove);
  document.addEventListener("mouseup", handleMouseUp);
  window.addEventListener("resize", handleResize);
}

/**
 * Fale Conosco garden: carrossel horizontal com scroll nativo (sem transform/RAF).
 * Evita conflito com scroll vertical da página e “pulos” do loop infinito.
 */
function initializeSlidesTalkGardenNative() {
  const track = document.querySelector(".privacy-slider .slide-track");
  const slider = document.querySelector(".privacy-slider");
  if (!track || !slider) return;

  track.innerHTML = "";
  state.slides = [];
  checkMobile();
  state.talkGardenNative = true;

  for (let i = 0; i < state.totalSlideCount; i++) {
    const slide = createPrivacySlideElement(i);
    track.appendChild(slide);
    state.slides.push(slide);
  }
  track.style.transform = "";

  let scrollLeftAtTouch = 0;
  let blockClickFromScroll = false;

  function sizeSlides() {
    const w = slider.clientWidth || 0;
    if (!w) return;
    state.slides.forEach((s) => {
      s.style.flexShrink = "0";
      s.style.flexGrow = "0";
      s.style.flexBasis = `${w}px`;
      s.style.width = `${w}px`;
      s.style.maxWidth = `${w}px`;
    });
  }

  state.talkGardenSizeSlides = sizeSlides;
  sizeSlides();
  requestAnimationFrame(() => {
    sizeSlides();
  });

  slider.addEventListener(
    "touchstart",
    () => {
      scrollLeftAtTouch = slider.scrollLeft;
      blockClickFromScroll = false;
    },
    { passive: true },
  );

  slider.addEventListener(
    "touchend",
    () => {
      blockClickFromScroll = Math.abs(slider.scrollLeft - scrollLeftAtTouch) > 14;
    },
    { passive: true },
  );

  state.slides.forEach((slide) => {
    slide.addEventListener("click", (e) => {
      if (blockClickFromScroll) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });
}

// Public API
function initializePrivacySlider(sliderData) {
  if (!sliderData || !Array.isArray(sliderData) || sliderData.length === 0) {
    console.error("Privacy Slider: Please provide valid slider data");
    return;
  }

  const track = document.querySelector(".privacy-slider .slide-track");
  if (!track) {
    console.warn("Privacy Slider: .privacy-slider .slide-track not found");
    return;
  }

  state.sliderData = sliderData;
  state.totalSlideCount = sliderData.length;

  if (isPrivacyGardenNativeLayout()) {
    initializeSlidesTalkGardenNative();
    if (!privacySliderListenersAttached) {
      privacySliderListenersAttached = true;
      window.addEventListener("resize", handleResize);
    }
    privacySliderLastResizeWidth = window.innerWidth;
    return;
  }

  state.talkGardenNative = false;
  state.talkGardenSizeSlides = null;

  initializeSlides();
  initializeEventListeners();

  if (!privacySliderAnimationStarted) {
    privacySliderAnimationStarted = true;
    animate();
  }
}

function tryAutoInitPrivacySlider() {
  if (typeof window.privacySliderData === "undefined") return;
  if (!Array.isArray(window.privacySliderData) || window.privacySliderData.length === 0) return;
  initializePrivacySlider(window.privacySliderData);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", tryAutoInitPrivacySlider);
} else {
  tryAutoInitPrivacySlider();
}

// Export for ES modules
export default function HorizontalSliderPrivacy(sliderData) {
  initializePrivacySlider(sliderData);
}

// Also make available for direct access
window.HorizontalSliderPrivacy = { initializeSlider: initializePrivacySlider };
